document.querySelectorAll(".skkg_vrnt_slct_area_row select[name='skkg_slct_data_B']")[0].addEventListener('change', slc_trgt => {
    var slc_data = slc_trgt.target.value;
    document.querySelectorAll(".skkg_vrnt_slct_area_row:has(input[name='skkg_slct_data_C'])")[0].setAttribute("data-skkgvsr_disp","true")
    /*document.querySelectorAll(".skkg_prd_gly_img-area img[data-skkg_dsp='true']")[0].setAttribute("data-skkg_dsp","false");
    document.querySelectorAll(".skkg_prd_gly_img-area img[data-skkg_imgchk='" + slc_data + "']")[0].setAttribute("data-skkg_dsp","true");*/
    mk_clr_slct();
    slc_vle();
});

/*document.querySelectorAll(".skkg_vrnt_slct_area_row input[name='skkg_slct_data_A']").forEach(inp_A_trgt => {
  inp_A_trgt.addEventListener("click", (inp_A_click) => {
    var size_ttl = "サイズ：" + inp_A_click.target.getAttribute("data-skcr_size_ttl").split("%%")[0] + "\n　　　　" + inp_A_click.target.getAttribute("data-skcr_size_ttl").split("%%")[1];
    document.querySelectorAll(".skkg_vrnt_slct_area_row:has(input[name='skkg_slct_data_A']) .skkg_vrnt_sa_row_ttl")[0].textContent = size_ttl;
    mk_clr_slct();
  });
});*/

function mk_clr_slct(){
    document.querySelectorAll(".skkg_vrnt_slct_area_row:has(input[name='skkg_slct_data_C']) .skkg_vrnt_sa_row_ttl")[0].textContent = "カラー";
    for(var a = 1;a <= 14;a++){
        var a_ind = "C_" + ( '00' + a ).slice( -2 );
        document.querySelectorAll(".skkg_vrnt_slct_area_row:has(input[name='skkg_slct_data_C']) input[value='" + a_ind + "']")[0].clicked = false;
        document.querySelectorAll(".skkg_vrnt_slct_area_row:has(input[name='skkg_slct_data_C']) label:has(input[value='" + a_ind + "'])")[0].setAttribute("data-skkgs_c_rdodisp","false");
    };
    document.querySelectorAll(".skkg_vrnt_slct_area_row:has(input[name='skkg_slct_data_C']) .skkg_vrnt_err.skve_01")[0].setAttribute("data-err_disp","false");
    document.querySelectorAll(".skkg_vrnt_slct_area_row:has(input[name='skkg_slct_data_C']) .skkg_vrnt_err.skve_02")[0].setAttribute("data-err_disp","false");
    var clr_data = {
        "A_01-B_01":["C_01","C_02","C_03","C_04","C_05"],
        "A_02-B_01":["C_01","C_02","C_03","C_04","C_05"],
        "A_02-B_02":["C_06","C_07","C_08","C_09"],
        "A_02-B_03":["C_10","C_11"],
        "A_02-B_04":["C_12","C_13","C_14"],
        "A_03-B_01":["C_01","C_02","C_03","C_04","C_05"],
        "A_03-B_02":["C_06","C_07","C_08","C_09"],
        "A_03-B_03":["C_10","C_11"],
        "A_03-B_04":["C_12","C_13","C_14"],
        "A_04-B_01":["C_01","C_02","C_03","C_04","C_05"],
        "A_04-B_02":["C_06","C_07","C_08","C_09"],
        "A_04-B_03":["C_10","C_11"],
        "A_04-B_04":["C_12","C_13","C_14"]
    };
    /*var A_data_base = document.querySelectorAll(".skkg_vrnt_slct_area_row input[name='skkg_slct_data_A']:checked");*/
    var A_data = document.querySelectorAll(".skkg_vrnt_slct_area")[0].getAttribute("data-skkg_vsa_size");
    var B_data = document.querySelectorAll(".skkg_vrnt_slct_area_row select[name='skkg_slct_data_B']")[0].value;
    var cnc_data = A_data + "-" + B_data;
    if(B_data != ""){
        if(cnc_data in clr_data){
            var colors = clr_data[cnc_data];
            for(var a = 0;a < colors.length;a++){
                document.querySelectorAll(".skkg_vrnt_slct_area_row:has(input[name='skkg_slct_data_C']) label:has(input[value='" + colors[a] + "'])")[0].setAttribute("data-skkgs_c_rdodisp","true");
            };
        }else{
            if(A_data == ""){
                document.querySelectorAll(".skkg_vrnt_slct_area_row:has(input[name='skkg_slct_data_C']) .skkg_vrnt_err.skve_01")[0].setAttribute("data-err_disp","true");
            }else{
                document.querySelectorAll(".skkg_vrnt_slct_area_row:has(input[name='skkg_slct_data_C']) .skkg_vrnt_err.skve_02")[0].setAttribute("data-err_disp","true");
            };
        };
    };
};

document.querySelectorAll(".skkg_vrnt_slct_area_row input[name='skkg_slct_data_C']").forEach(inp_C_trgt => {
  inp_C_trgt.addEventListener("click", () => {
    var value_ttl = "カラー：" + inp_C_trgt.getAttribute("data-skcr_color_ttl");
    document.querySelectorAll(".skkg_vrnt_slct_area_row:has(input[name='skkg_slct_data_C']) .skkg_vrnt_sa_row_ttl")[0].textContent = value_ttl;
    slc_vle();
  });
});

document.querySelectorAll(".skkg_vrnt_slct_area_row input[name='skkg_slct_data_D']").forEach(inp_D_trgt => {
  inp_D_trgt.addEventListener("click", () => {
    var value_ttl = "脚：" + inp_D_trgt.getAttribute("data-skcr_leg_ttl");
    document.querySelectorAll(".skkg_vrnt_slct_area_row:has(input[name='skkg_slct_data_D']) .skkg_vrnt_sa_row_ttl")[0].textContent = value_ttl;
    slc_vle();
  });
});

function slc_vle(){
  document.querySelectorAll(".skkg_vrnt_slct_area_row[data-skkg_rslt_disp]")[0].setAttribute("data-skkg_rslt_disp","false");
  /*var A_data_base = document.querySelectorAll(".skkg_vrnt_slct_area")[0].getAttribute("data-skkg_vsa_size");
  var size_list = {"A_01":"1人掛","A_02":"2人掛","A_03":"2.5人掛","A_04":"3人掛"};*/
  var B_data_base = document.querySelectorAll(".skkg_vrnt_slct_area_row select[name='skkg_slct_data_B']")[0].value;
  var hlz_list = {"B_01":"SPL（合成皮革）","B_02":"EVL（合成皮革）","B_03":"ファブリック（布）","B_04":"レザー（本革）"};
  /*var A_data = size_list[A_data_base];*/
  var B_data = hlz_list[B_data_base];
  var C_data_base = document.querySelectorAll(".skkg_vrnt_slct_area_row input[name='skkg_slct_data_C']:checked");
  if(C_data_base.length > 0){var C_data = document.querySelectorAll(".skkg_vrnt_slct_area_row input[name='skkg_slct_data_C']:checked")[0].getAttribute("data-skcr_color_ttl");}else{var C_data = ""};
  var D_data_base = document.querySelectorAll(".skkg_vrnt_slct_area_row input[name='skkg_slct_data_D']:checked");
  if(D_data_base.length > 0){var D_data = document.querySelectorAll(".skkg_vrnt_slct_area_row input[name='skkg_slct_data_D']:checked")[0].getAttribute("data-skcr_leg_ttl");}else{var D_data = ""};
  /*var total_value = A_data + " - " + B_data + " - " + C_data + " - " + D_data;*/
  var total_value = B_data + " - " + C_data + " - " + D_data;
  var select_list = [];
  var opt_arry = document.querySelectorAll(".product-form__single-selector option");
  for(var a = 0;a < opt_arry.length;a++){
    select_list.push(opt_arry[a].getAttribute("value"));
  };
  if(select_list.includes(total_value)){
    document.querySelectorAll(".product-form__single-selector")[0].value = total_value;
    var vrnt_data = JSON.parse(document.querySelectorAll(".skkg_vrnt_slct_area")[0].getAttribute("data-skkg_vrnt_list"));
    var subm = document.querySelectorAll(".acpt_giji_btn")[0].getAttribute("data-acpt_hn_btn");
    var acp_svi = vrnt_data[total_value][0];
    var acp_spr = document.createTextNode(vrnt_data[total_value][1]);
    document.querySelectorAll("#" + subm + " select[name='id'] option[value='" + acp_svi + "']")[0].selected = true;
    var disabl = document.querySelectorAll("#" + subm + " select[name='id'] option[value='" + acp_svi + "']")[0].getAttribute("disabled");
    console.log(disabl);
    if(disabl == "disabled"){
      document.querySelectorAll(".acpt_giji_btn")[0].setAttribute("data-dssbl_stts","disabl");
    }else{
      document.querySelectorAll(".acpt_giji_btn")[0].setAttribute("data-dssbl_stts","");
    };
    var acp_befel = document.createElement("span");acp_befel.setAttribute("class","visually-hidden");acp_befel.textContent = "販売価格";
    document.querySelectorAll("#" + subm + " .price-list .price")[0].textContent = "";
    document.querySelectorAll("#" + subm + " .price-list .price")[0].appendChild(acp_befel);
    document.querySelectorAll("#" + subm + " .price-list .price")[0].appendChild(acp_spr);
    document.querySelectorAll(".skkg_selected_image")[0].setAttribute("src",vrnt_data[total_value][2]);
    var acp_u = new URL(window.location.href);
    var acp_p = acp_u.searchParams;
    acp_p.set("variant",acp_svi);
    acp_u.search = acp_p.toString();
    window.history.pushState({}, "", acp_u);
    document.querySelectorAll(".skkg_vrnt_slct_area_row[data-skkg_rslt_disp]")[0].setAttribute("data-skkg_rslt_disp","true");
    document.querySelectorAll(".skkg_img_loading_cnt[data-skkg_rslimg_lddsp]")[0].setAttribute("data-skkg_rslimg_lddsp","true");
    return total_value;
  }else{
    return "";
  };
};

document.querySelectorAll(".acpt_giji_btn")[0].addEventListener('click', acpt_giji_btn => {
  var subm = document.querySelectorAll(".acpt_giji_btn")[0].getAttribute("data-acpt_hn_btn");
  acpt_giji_btn.preventDefault();
  var vrnt_base = slc_vle();
  if(vrnt_base != ""){
    document.getElementById(subm).getElementsByClassName("product-form__add-button")[0].click();
  };
});

document.querySelectorAll(".skkg_selected_image")[0].addEventListener('load', () => {
  setTimeout(()=>{document.querySelectorAll(".skkg_img_loading_cnt[data-skkg_rslimg_lddsp]")[0].setAttribute("data-skkg_rslimg_lddsp","false");}, 200);
});

